var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 698,
    viewBox: "0 0 604 698",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.121 0.490234L116.898 107.311L184.995 146.774L302.121 79.4152L419.245 146.774L487.342 107.311L302.121 0.490234ZM419.245 202.566L487.342 242.028V320.953L370.215 388.311V523.029L302.121 562.492L234.024 523.029V388.311L116.898 320.953V242.028L184.995 202.566L302.121 269.923L419.245 202.566ZM487.342 376.745V455.67L419.245 495.134V416.206L487.342 376.745ZM418.564 550.923L535.692 483.565V348.848L603.786 309.387V523.029L418.564 629.848V550.923ZM535.692 214.132L467.594 174.67L535.692 135.207L603.786 174.67V253.595L535.692 293.058V214.132ZM234.024 658.426V579.501L302.121 618.962L370.215 579.501V658.426L302.121 697.887L234.024 658.426ZM184.995 495.134L116.898 455.67V376.745L184.995 416.206V495.134ZM302.121 214.132L234.024 174.67L302.121 135.207L370.215 174.67L302.121 214.132ZM136.646 174.67L68.5493 214.132V293.058L0.453125 253.595V174.67L68.5493 135.207L136.646 174.67ZM0.453125 309.387L68.5493 348.848V483.565L185.675 550.923V629.848L0.453125 523.029V309.387Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscIcon);
export default __webpack_public_path__ + "static/media/bsc-icon.82194792f94576c870f0bb1eb184d28e.svg";
export { ForwardRef as ReactComponent };